module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('div', {
    staticClass: "SOM_titre"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-001"
    }
  }, [_vm._v("Bible versions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-002"
    }
  }, [_vm._v("1. Title of the book")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-003"
    }
  }, [_vm._v("2. Titles to the individual psalms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-001"
    }
  }, [_vm._v("a. Authorship titles and historical titles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-002"
    }
  }, [_vm._v("b. Genre titles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-003"
    }
  }, [_vm._v("c. Musical and performance titles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-004"
    }
  }, [_vm._v("d. Liturgical titles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-004"
    }
  }, [_vm._v("Excursus: "), _c('i', [_vm._v("Selāh and Higgāyôn")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-005"
    }
  }, [_vm._v("3. Composition, collection, organization, use")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-005"
    }
  }, [_vm._v("a. Composition and collection")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-006"
    }
  }, [_vm._v("b. Organization")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-007"
    }
  }, [_vm._v("c. Use")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-006"
    }
  }, [_vm._v("4. Genre and types of psalms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-008"
    }
  }, [_vm._v("a. Hymns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-009"
    }
  }, [_vm._v("b. Laments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-010"
    }
  }, [_vm._v("c. Thanksgiving songs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-011"
    }
  }, [_vm._v("d. Confidence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-012"
    }
  }, [_vm._v("e. Prophetic")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-013"
    }
  }, [_vm._v("f. Wisdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-014"
    }
  }, [_vm._v("g. Remembrance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-015"
    }
  }, [_vm._v("h. Royal")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-007"
    }
  }, [_vm._v("5. Poetic style")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-016"
    }
  }, [_vm._v("a. Terseness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-017"
    }
  }, [_vm._v("b. Parallelism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-018"
    }
  }, [_vm._v("c. Imagery")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-019"
    }
  }, [_vm._v("d. Secondary poetical devices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv2-020"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-008"
    }
  }, [_vm._v("6. The theology of the book of Psalms")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-009"
    }
  }, [_vm._v("7. The Psalms as a mirror of the soul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-010"
    }
  }, [_vm._v("Excursus: Imprecations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-011"
    }
  }, [_vm._v("8. Worship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6#niv1-012"
    }
  }, [_vm._v("9. How to read this commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 1: Psalms 1 – 41")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 1. The way of the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1–3. Blessing on the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:4–5. Punishment on the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:7–8. The two ways")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 2. The Lord and his anointed")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:1–3. Human rebellion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:4–6. Divine ridicule")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:7–9. You are my son")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:10–12. Kiss his son")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 3. How many are my foes!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:1–2. Many are my foes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:3–6. The Lord sustains me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:7. Arise, Lord!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:8. Deliverance comes from the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 4. An evening prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:1. Have mercy on me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:2–3. Glory into shame")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:4–5. Do not sin")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:6–7. Give us prosperity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:8. I will sleep in peace")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 5. A morning prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:1–2. Consider my plea")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:3–7. Worship in the sanctuary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:8–11. Punishment for the wicked and protection for God’s people")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:12. Bless the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 6. Do not discipline me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:1–3. How long?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:4–5. Save me!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:6–7. My tears")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:8–10. The Lord has heard me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 7. God battles against evil people")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:1–2. Save me from the lions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:3–5. I am innocent")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:6–9. Arise!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:10–13. God the Warrior")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:14–16. Trouble that rebounds on the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:17. Worship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 8. God’s glory in the heavens")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:1a. How majestic!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:1b–4. What is humanity?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:5–8. A little lower than God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:9. How majestic!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 9. Arise, O Lord (part 1)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:1–2. Thank you!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:3–6. You have rebuked the nations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:7–10. God reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:11–12. God remembers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:13–14. Have mercy on me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:15–18. Trouble that rebounds on the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:19–20. Arise Lord!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 10. Arise, O Lord (part 2)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10:1. Where are you, God?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10:2–11. The wicked man")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10:12–15. Arise!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10:16–18. God is King")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 11. In the Lord I take refuge")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11:1–3. When the foundations are being destroyed")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11:4–7. The Lord is in his holy temple")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 12. God protects the needy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12:1–4. They are all liars")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12:5–8. You keep all the needy safe")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 13. How long, O Lord?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13:1–2. How long, Lord?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13:3–4. Give light to my eyes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13:5–6. Confidence and praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 14. ‘There is no God’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14:1. There is no God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14:2–3. Do any understand?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14:4–6. Oppressing the poor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14:7. Desiring restoration")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 15. Who can enter the sanctuary?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15:1. Who may dwell in your tent?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15:2–5b. Blameless and righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15:5c: Never shaken")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 16. You will not abandon me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16:1. Keep me safe")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16:2–4. God is Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16:5–8. A delightful inheritance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16:9–11. The path of life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 17. Vindicate me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:1–2. Hear my prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:3–5. Examine me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:6–9. Protect me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:10–12. Enemy predators")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:13–15. Rise up, Lord!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 18. The Divine Warrior rescues the king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:1. I love you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:2. My protection")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:3–5. I almost died")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:6–15. God rides into battle")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:16–19. The rescue")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:20–24. God’s reward")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:25–29. The humble and the haughty")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:30–36. The Lord is the only God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:37–49. Victory")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:50. God loves David")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 19. The heavens declare God’s glory")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19:1–6. The heavens declare")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19:7–11. The glorious law of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19:12–13. Forgive me and guide me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19:14. The meditation of my heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 20. Prayer for the king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20:1–5. May God answer you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20:6–8. Victory!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20:9. Answer us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 21. Past and future victory")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21:1. The king rejoices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21:2–7. God has answered the king’s prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21:8–12. God will destroy the king’s enemies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21:13. Be exalted")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 22. My God, my God, why have you forsaken me?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:1–2. Why?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:3–5. You rescued our ancestors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:6–8. I am a worm")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:9–10. Since birth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:11. Come close")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:12–18. The attack of the enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:19–21. Come close")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:22–31. I will praise you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 23. The Lord is my shepherd")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23:1–4. The Lord is my shepherd")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23:5–6. The Lord is my host")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 24. Lift up your heads, you gates")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24:1–2. God the Creator")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24:3–6. Who can enter the holy place?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24:7–10. Lift up your heads, you gates!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 25. Trust in the midst of suffering")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:1–3. I trust you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:4–7. Teach me your ways")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:8–11. God is good")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:12–15. God blesses the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:16–21. Help me, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:22. Deliver Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 26. I have led a blameless life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26:1–3. Vindicate me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26:4–7. I am innocent")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26:8–11. Preserve my life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26:12. Thank you, God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 27. The Lord is my light and my salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:1. Whom shall I fear?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:2–3. The enemy will not prevail")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:4–5. Safe in his dwelling")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:6. I will praise God who exalts me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:7–10. Answer me, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:11–12. False accusations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:13–14. Wait for the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 28. You are my Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28:1–2. I call to my Rock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28:3–5. Don’t treat me like the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28:6–9. Thank God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 29. Praise the God of the storm")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29:1–2. Ascribe to the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29:3–9. God’s voice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29:10–11. God the King")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 30. Thanks for healing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30:1–3. Preliminary thanksgiving")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30:4–5. Join in the praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30:6–10. Redemptive abandonment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30:11–12. God’s answer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 31. Into your hands I commit my spirit")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:1–5. Protect me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:6–8. You have preserved me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:9–13. I am in distress")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:14–18. I trust you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:19–20. You hide your people")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:21–22. Praise God!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:23–24. Love the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 32. Blessed is the one whose sins are covered")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32:1–2. Blessed are the forgiven")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32:3–4. Your heavy hand")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32:5. I confess and you forgive")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32:8–11. I will teach you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 33. No king is saved by the size of his army")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:1–3. A new song")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:4–5. The word of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:6–9. God made the heavens by his word")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:10–11. God’s plans prevail")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:12–15. God sees all")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:16–19. God saves")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33:20–22. Waiting for the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 34. Taste and see that the Lord is good")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:1–3. Glorify the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:4–7. God heard my prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:8–14. Taste and see")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:15–16. God is for the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:17–20. God hears the prayers of the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34:21–22. Consequences for the wicked and God’s servants")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 35. Contend with them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:1–3. Contend, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:4–6. Shame them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:7–10. Ruin them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:11–16. False witnesses")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:17–21. How long?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:22–25. Contend!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:26–27. Shame them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35:28. I will praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 36. See how the evildoers lie fallen!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36:1–4. The wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36:5–9. God’s gracious character")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36:10–12. Continue your love towards us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 37. Do not fret")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:1–11. Do not fret")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:12–15. The wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:16–17. Better righteousness than wealth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:18–22. The righteous and the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:23–24. Security for the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:25–26. God blesses the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:27–29. Turn from evil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:30–33. The righteous and the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:34. Hope")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:35–38. Like a luxuriant tree")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37:39–40. God saves")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 38. Lord, do not forsake me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38:1–8. I am in pain")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38:9–12. Others avoid me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38:13–16. I am needy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38:17–20. Confession")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38:21–22. Do not forsake me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 39. Look away from me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39:1–3. I had to speak")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39:4–6. The fragility of life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39:7–11. Remove your scourge")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39:12–13. Hear my prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 40. I desire to do your will")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:1–3. A new song")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:4–5. Trust God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:6–8. You want obedience")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:9–10. I proclaim your greatness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:11–13. Save me!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40:14–17. Shame my enemies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 41. Blessed are those who have regard for the weak")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41:1–3. Blessed are the caregivers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41:4–9. Heal me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41:10–12. Have mercy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv2-214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41:13. Doxology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 2: Psalms 42 – 72")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalms 42 – 43. Why, my soul, are you downcast")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:1–4. As the deer pants")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:5. Put your hope in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:6–7. I will remember you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:8. God is with me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:9–10. Divine abandonment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42:11. Put your hope in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43:1–4. Vindicate me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43:5. Put your hope in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 44. Awake, Lord! Why do you sleep?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:1–3. You won victories for our ancestors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:4–8. You won victories for us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:9–16. You have abandoned us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:17–19. We have remained faithful")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:20–22. We face death")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44:23–26. Awake!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 45. A noble theme")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45:1. My tongue is a pen")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45:2–9. The glory of the groom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45:10–15. The glory of the bride")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45:16–17. The king’s legacy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 46. An ever-present help")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46:1–3. We will not fear")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46:4–7. God is with us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46:8–11. Be still")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 47. Proclaiming God as King")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47:1. Clap your hands")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47:2–4. God the King")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-238",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47:5–7. God ascends to his throne")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47:8–9. God reigns over the nations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 48. Zion, like Zaphon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:1. Worthy of praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:2–3. Beautiful Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:4–7. The attacking nations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:8. The city of our God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:9–11. God’s unfailing love")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48:12–14. Consider Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 49. God will redeem me from the realm of death")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49:1–4. Words of wisdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49:5–12. All die")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49:13–19. Death comes to the wealthy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49:20. Like beasts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 50. He is a God of justice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50:1–6. Gather to me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50:7–13. I don’t need your sacrifices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50:14–21. You are evil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50:22–23. Honour me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 51. Forgive me, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:1–2. Have mercy on me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:3–6. I am a sinner")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:7–9. Cleanse me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:10–12. Restore me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:13–17. A contrite heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51:18–19. Prosper Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 52. I am like an olive tree")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52:1–4. You mighty hero")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52:5–7. The downfall of the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52:8–9. Like an olive tree")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 53. ‘There is no God’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 54. Arrogant foes are attacking me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54:1–3. Save me from my foes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54:4–5. God is my help")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54:6–7. I will praise you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 55. Cast your cares on the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:1–3. Listen, O God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:4–8. Fear and trembling")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:9–11. Violence in the city")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:12–15. Betrayed by a close friend")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:16–19. Enthroned from of old")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55:20–23. I trust in you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 56. What can mere mortals do to me?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:1–2. Be merciful")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:3–4. What can mere mortals do to me?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:5–7. The complaint")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:8–9. Record my misery")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-276",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:10–11. What can man do to me?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56:12–13. Vows")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 57. Let your glory be over all the earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:1. In the shadow of your wings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:2–3. God saves me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:4. Vicious enemies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:5. Be exalted")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:6. Their downfall")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:7–10. Be steadfast")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57:11. Be exalted")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 58. The injustice of rulers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58:1–5. The poison of evil rulers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58:6–8. Destroy them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58:9–11. The wicked will disappear")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 59. Snarling like dogs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59:1–2. Deliver me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59:3–5. Arise to help me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59:6–8. Snarling like dogs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59:9–13. Do not kill them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59:14–17. Snarling like dogs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 60. With God we will gain the victory")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60:1–4. You have rejected us, now restore us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60:5–8. God’s triumph")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60:9–12. Give us aid, God!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 61. The rock that is higher than I")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61:1–3. From the ends of the earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61:4–5. In your tent forever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61:6–8. A prayer for the king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 62. My soul finds rest in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62:1–2. My rock and my salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62:3–4. About to fall")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62:5–8. My rock and my salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62:9–10. Humans are nothing")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62:11–12. God has spoken")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 63. I thirst for you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63:1. A thirst for God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63:2–5. Past satisfaction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63:6–8. In the shadow of your wing"), _c('i', [_vm._v("s")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63:9–12. My enemy will be vanquished")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 64. Conspiracy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64:1–6. The conspiracy of the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64:7–10. God’s response")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 65. You care for the land")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65:1–4. You forgave our transgressions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65:5–8. Wonders of the whole earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65:9–13. God’s provision for the land")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 66. Come and see what God has done")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66:1–4. Praise God!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66:5–7. Come and see!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66:8–12. He has preserved our lives")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66:13–15. I will come to your temple")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66:16–20. Come and hear!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 67. May the peoples praise you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67:1–5. May the whole earth praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67:6–7. Thanks for the harvest.")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 68. Extol him who rides on the clouds")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:1–3. Scatter the enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:4–6. The cloud rider")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:7–10. Through the wilderness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:11–14. Celebration")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:15–18. From Sinai to Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-325",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:19–23. Our God is a God who saves")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:24–27. The procession")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:28–31. Bringing tribute to God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68:32–35. Final call to praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 69. Persecuted because of righteousness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:1–4. Initial invocation, appeal for help and first complaint")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:5–6. Confession of sin")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:7–12. Second complaint")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:13–18. Further appeals for help")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:19–21. Third complaint")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:22–29. A curse on the enemies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:29. Final complaint")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69:30–36. Concluding praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 70. Hasten to save me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 71. Protect me when I am old")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71:1–4. Be my protection")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71:5–8. My hope since my youth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71:9–13. Now that I am old")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71:14–18. Proclaiming your mighty acts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-341",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71:19–21. You will bring me up again")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71:22–24. Praising God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 72. A prayer for the king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72:1–2. A just king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72:3–7. Prosperity flowing from righteousness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72:8–11. May all the kings submit to him")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72:12–14. Help for the vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72:15–17. Long live the king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv2-348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72:18–20. Final doxology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 3: Psalms 73 – 89")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 73. Struggling with the prosperity of the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:1–2. God is good")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-350",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:3–12. Feeling envy for the prosperity of the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:13–14. My meaningless life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:15–20. Their final destiny")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:21–22. A brute beast")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-354",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:23–26. Into glory")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73:27–28. Those who are far and those who are near")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 74. Punish those who desecrated the sanctuary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74:1–3. Why have you rejected us?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74:4–8. They burned the sanctuary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74:9–11. How long?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74:12–17. You crushed the heads of Leviathan")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74:18–23. Rise up, O God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 75. The divine Judge")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75:1. Praising God’s name")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75:2–5. Judging the proud")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75:6–8. The cup of wrath")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-364",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75:9–10. Praising God who judges the proud")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 76. God the Warrior dwells in Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76:1–3. His tent is in Salem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76:4–6. God destroys the enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76:7–10. Who can stand before God?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-368",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76:11–12. Fulfil your vows")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 77. Looking to the past for help in the present")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77:1–2. Crying to God in the night")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-370",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77:3–6. First remembrance")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77:7–9. Questioning God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-372",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77:10–11. The mighty acts of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77:13–15. God is great")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77:16–20. The crossing of the sea")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 78. So the next generation will know")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:1–8. Hear a parable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-376",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:9–16. The men of Ephraim")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:17–31. They continued to sin")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-378",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:32–39. God was merciful")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:40–55. The plagues of Egypt")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:56–64. They angered God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78:65–72. He chose David and Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 79. From the rubble of Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-382",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79:1–4. The nations have invaded Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79:5–7. How long, Lord?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79:8–13. Help us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 80. Make your face shine on us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:1–2. Shepherd of Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:3. Make your face shine on us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:4–6. How long?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:7. Make your face shine on us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:8–11. The transplanted vine")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-390",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:12–15. The ravaged vineyard")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:16–18. Revive us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-392",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80:19. Make your face shine on us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 81. Honey from the rock")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81:1–5b. Praising God at the New Moon festival")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-394",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81:5b–10. An unknown voice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81:11–12. Disobedient Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81:13–16. Turn and be rescued")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 82. Judging the gods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82:1–4. God in the assembly of the gods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-398",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82:5. The failure of the gods")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82:6–7. A warning")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82:8. Rise up, O God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 83. Make them like tumble-weed")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83:1–8. The plots of the enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-402",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83:9–16. Destroy our enemies, God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83:17–18. You alone are Most High")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 84. How lovely is your dwelling-place")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84:1–7. Blessed are those who are close to God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84:8–9. Care for the king")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84:10–12. Better one day in the temple")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 85. Righteousness and peace kiss each other")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85:1–3. You restored our fortunes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85:4–7. Restore our fortunes again!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85:8–9. His salvation is near")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-410",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85:10–13. Confident in his covenantal faithfulness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 86. When I am in distress, I call to you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86:1–7. I am poor and needy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-412",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86:8–10. All the nations will worship God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86:11–13. Teach me and I will praise you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86:14–17. Have mercy on me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-098",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 87. Glorious things are said")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87:1–2. The city on the mountain")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-416",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87:3–7. The register of the peoples")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 88. Darkness is my closest friend")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88:1–2. The God who saves me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-418",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88:3–5. Overwhelmed with troubles")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88:6–12. You, God, have ruined my life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-420",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88:13–14. Why do you reject me?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88:15–18. Darkness is my closest friend")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 89. Where is your former great love?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:1–4. God’s promise to David")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:5–8. The heavens praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:9–13. God is sovereign over heaven and earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:14–18. God our King")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-426",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:19–29. David my servant")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:30–37. His line will continue forever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-428",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:38–45. You have renounced the covenant")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-429",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:46–51. How long, Lord?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv2-430",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89:52. Doxology to Book 3")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 4: Psalms 90 – 106")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 90. Establish the work of our hands")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90:1–2. Our dwelling-place")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-432",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90:3–6. Fragility of life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90:7–12. A heart of wisdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90:13–17. Relent, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 91. Under his wings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-435",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91:1–2. My protection")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-436",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91:3–8. God will save you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91:9–13. No harm will overtake you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-438",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91:14–16. ‘I will rescue him’")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 92. Like a palm tree")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-439",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92:1–3. Praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92:4–7. Great are your works")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-441",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92:8–11. Defeated enemies")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-442",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92:12–15. Planted in the house of the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 93. The Lord reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-443",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93:1–2. The Lord reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-444",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93:3–5. Mightier than the seas")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-445",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93:5. Your statutes stand firm")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 94. A God who avenges")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94:1–3. Judge of the earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-447",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94:4–7. The wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-448",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94:8–11. You fools")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94:12–15. Blessed are your people")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-450",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94:16–19. God helps me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-451",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94:20–23. God is my fortress")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 95. Do not harden your hearts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95:1–2. Our Protector")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-453",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95:3–5. Our great God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95:6–7c. Our Shepherd")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95:7d–11. Do not harden your hearts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 96. A new song")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-456",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96:1–3. Sing a new song")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-457",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96:4–6. Great is the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-458",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96:7–10. The Lord reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-459",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96:11–13. Let the world rejoice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 97. Let the earth be glad")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97:1–6. The Lord reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-461",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97:7. Worship him")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97:8–12. You are exalted")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 98. God the Victor, King and Judge")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-463",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98:1–3. Israel, praise God your Victor in the past")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-464",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98:4–6. All the earth, praise God your King in the present")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-465",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98:7–9. All of creation, praise God your Judge in the future")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 99. Let the nations tremble")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-466",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99:1–3. The Lord reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-467",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99:4–5. Worship at his footstool")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-468",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99:6–9. Exalt the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 100. Enter his gates with thanksgiving")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-469",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100:1–3. We are his")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100:4–5. Give thanks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 101. A blameless heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-471",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101:1–4. I will follow you, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-472",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101:5. I will put to silence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101:6. I will associate with the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101:7–8. I will put to silence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 102. I am in distress")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-475",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102:1–2. Hear my prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-476",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102:3–11. I suffer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-477",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102:12–17. Rebuilding Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-478",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102:18–22. Declaring God’s praise in Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102:23–28. You remain the same")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 103. Forget not all his benefits")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103:1–5. O my soul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-481",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103:6–12. God’s character")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-482",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103:13–18. As a Father")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-483",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103:20–22. Praise the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 104. Creator and Sustainer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-484",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:1. O my soul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-485",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:2–4. He rides the wind")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:5–9. He set the earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-487",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:10–18. He provides waters")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-488",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:19–23. The moon and the sun")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-489",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:24–26. In wisdom you made them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-490",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:27–30. You provide food")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-491",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:31–32. The glory of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-492",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104:33–35. O my soul")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 105. He remembered his holy promise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-493",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:1–4. Seek his face")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-494",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:5–7. His judgments")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-495",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:8–11. He remembers his covenant")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-496",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:12–15. The patriarchs")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-497",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:16–23. Joseph")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-498",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:24–38. Moses and the exodus")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-499",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:39–41. The wilderness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-500",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105:42–45. The conquest")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv1-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 106. We have sinned like our ancestors")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-501",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:1–3. Praise the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-502",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:4–5. Remember me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:6–12. Our ancestors sinned, but you saved them")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-504",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:13–15. They forgot")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-505",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:16–23. Judgment in the wilderness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-506",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:24–27. Grumbling in the wilderness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:28–33. Rebellion in the wilderness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-508",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:34–39. Mingling with the nations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:40–46. He remembered his covenant")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-510",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:47. Save us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4#niv2-511",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106:48. Doxology to Book 4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book 5: Psalms 107 – 150")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 107. Give thanks to the Lord for his unfailing love")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-512",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:1–3. A story of redemption")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:4–9. Returning from the desert wasteland")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-514",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:10–16. Out of darkness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:17–22. Some became fools")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:23–32. Calming the storm waters")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-517",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:33–38. Desert into pools")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-518",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:39–42. Lifting the needy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-519",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107:43. Be wise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 108. Let your glory be over all the earth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 109. At the right hand of the needy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-520",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109:1–5. A man of prayer")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-521",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109:6–15. Find him guilty")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-522",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109:16–20. Curse him")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-523",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109:21–29. Help me, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109:30–31. He helps the needy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 110. A priest forever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-525",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110:1. Sit at my right hand")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-526",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110:2–3. Extending the king’s rule")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-527",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110:4. In the order of Melchizedek")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-528",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110:5–7. At God’s right hand")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 111. I will extol the Lord with all my heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111:1. Praise the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-530",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111:2–5. Great are his works")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111:6–9. Conquest and covenant")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-532",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111:10. Fear of the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 112. Blessed are those who fear the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-533",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112:1. Praise the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-534",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112:2–5. Prosperity for the wise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-535",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112:6–9. Their hearts are secure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-536",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112:10. The wicked gnash their teeth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 113. He raises the poor from the dust")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-537",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113:1–3. Praise the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113:4–6. Who is like the Lord?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113:7–9. He helps the vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 114. When Israel came out of Egypt")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-540",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114:1–2. God’s sanctuary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-541",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114:3–6. Sea and mountains")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-542",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114:7–8. God’s fearsome presence")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 115. Trust in the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-543",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115:1. Glory to God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-544",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115:2–8. God against the idols")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-545",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115:9–11. Trust the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-546",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115:12–13. He will bless us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-547",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115:14–15. May God bless you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-548",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115:16–17. Praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 116. He heard my voice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-549",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:1–2. He heard me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-550",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:3–4. Save me from death")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-551",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:5–6. God protects the unwary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-552",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:7–9. God saved me from death")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-553",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:10–11. Trust in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-554",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:12–14. Cup of salvation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-555",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:15–16. Costly is the death of God’s servants")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-556",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116:17–19. Vows and thank-offerings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 117. Great is his love towards us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 118. The stone the builders rejected")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-557",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:1–4. His love endures for ever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-558",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:5–7. The Lord is with me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-559",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:8–14. Take refuge in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-560",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:15–21. The Lord’s right hand")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-561",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:22–24. The cornerstone")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-562",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:25. Save us!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-563",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:26–27. He who comes in the name of the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-564",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118:28–29. His love endures for ever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 119. I love your law")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus: Psalms of ascent")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 120. I am for peace")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-565",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120:1–2. Deliver me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120:3–4. God’s punishment")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120:5–6. Among hostile strangers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 121. God watches over you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-568",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121:1–2. Help comes from the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121:3–4. God does not sleep")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-570",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121:5–6. The Lord provides shade")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-571",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121:7–8. The Lord watches over you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 122. Pray for the peace of Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-572",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122:1–2. Let’s go to the house of the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-573",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122:3–5. Magnificent Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-574",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122:6–9. Pray for the peace of Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 123. I lift my eyes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-575",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123:1–2. Submission")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-576",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123:3–4. Enduring contempt")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 124. The Lord is on our side")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-577",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124:1–5. The Lord is on our side")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-578",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124:6–8. Escape")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 125. Trust God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-579",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125:1–2. Trust in God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-580",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125:3. The fall of the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-581",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125:4–5. Peace")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 126. The restoration of Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-582",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126:1–3. Joy in restoration")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-583",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126:4–6. Restore us")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 127. Unless the Lord builds the house")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-584",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127:1–2. Unless the Lord builds")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-585",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127:3–5. Children are a heritage")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 128. The fear of the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-586",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128:1–4. Family blessings")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-587",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128:5–6. May the Lord bless you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 129. Oppressed from my youth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-588",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129:1–4. Oppressed from youth")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-589",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129:5–8. Those who hate Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 130. Out of the depths")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-590",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130:1–2. Out of the depths")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-591",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130:3–4. Forgiveness")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-592",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130:5–6. Waiting for the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-593",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130:7–8. Hope in the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 131. Like a mother")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-594",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131:1–2. Confidence in the midst of turmoil")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-595",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131:3. Hope in the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 132. Remember David")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-596",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132:1. Remember David")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-597",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132:2–5. David’s promise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-598",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132:6–9. Arise, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-599",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132:10–12. David’s descendants")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-600",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132:13–16. Zion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-601",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132:17–18. David’s strength")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 133. Living in unity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-602",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133:1. Living in unity")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-603",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133:2–3. How precious!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 134. The Lord bless you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-604",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134:1–2. Lift up your hands")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-605",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134:3. The Lord bless you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 135. The Lord is God and the Lord is great")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-606",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:1–2. Praise the Lord!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-607",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:3–4. God has chosen Israel")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-608",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:5–7. God is great")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-609",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:8–12. God the Warrior")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-610",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:13–14. God’s reputation")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-611",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:15–18. Vain idols")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-612",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135:19–21. Praise the Lord!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 136. His love endures forever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-613",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136:1–3. Give thanks")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-614",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136:4–9. He creates")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-615",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136:10–15. He redeems")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-616",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136:16. He guides")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-617",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136:17–22. He conquers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-618",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136:23–26. He provides")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 137. By the rivers of Babylon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-619",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137:1–3. By the rivers of Babylon")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-620",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137:4–6. If I forget Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-621",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137:7–9. Destroy the Edomites")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 138. With all my heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-622",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138:1–3. I will praise you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-623",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138:4–5. Let kings praise you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-624",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138:6–8. God helps the vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 139. Search me, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-625",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139:1–6. You hem me in")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-626",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139:7–12. Where can I go?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-627",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139:13–18. You know me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-628",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139:19–24. Vindicate me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 140. Justice for the poor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-629",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140:1–3. Rescue me!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-630",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140:4–5. Protect me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-631",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140:6–8. You are my God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-632",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140:9–11. Destroy the enemy")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-633",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140:12–13. God protects the vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 141. My prayer like incense")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-634",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141:1–2. Like incense")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-635",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141:3–4. Guard my mouth and heart")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-636",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141:5. The discipline of the righteous")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-637",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141:6–7. The punishment of the wicked")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-638",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141:8–10. Keep me safe")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 142. No refuge but you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-639",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142:1–2. I cry to the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-640",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142:3–4. No-one cares")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-641",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142:5. You are my portion")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-642",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142:6–7. Set me free")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 143. No-one is righteous before you")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-643",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143:1–4. The enemy pursues me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-644",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143:5–7. I remember")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-645",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143:8–10. Rescue me")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-646",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143:11–12. Preserve my life")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 144. He trains my hand for war")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-647",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144:1–2. My Protector")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-648",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144:3–4. What are human beings?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-649",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144:5–8. Come down, Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-650",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144:9–11. A new song")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-651",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144:12–15. Then we will be blessed")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 145. Your kingdom is everlasting")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-652",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145:1–2. God the King")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-653",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145:3–7. Worthy of praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-654",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145:8. Gracious and compassionate")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-655",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145:9–13a. An everlasting kingdom")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-656",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145:13b–20. The Lord watches the vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-657",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145:21. Praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 146. The Lord reigns forever")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-658",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146:1. Halĕlû yāh")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-659",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146:2–9. God defends the vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-660",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146:10. The Lord reigns")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 147: How fitting to praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-661",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:1. Halĕlû yāh")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-662",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:2–6. God builds up Jerusalem")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-663",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:7. Sing to the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:8–9. God provides")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-665",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:10–11. God loves those who fear him")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:12. Extol the Lord")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147:13–20. God provides")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 148. The whole cosmos praises God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-668",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148:1–6. O heavens, halĕlû yāh!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-669",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148:7–12. O earth, halĕlû yāh!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-670",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148:13–14. O Israel, halĕlû yāh!")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 149. A sword in their hands")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-671",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149:1. Halĕlû yāh")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-672",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149:2–5. Let Israel praise God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-673",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149:6–9. Praise God in battle")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psalm 150. Final doxology")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-674",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150:1. The place of praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-675",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150:2. The reasons for praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-676",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150:3–5. The means of praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-677",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150:6. An invitation to praise")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Tyndale Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/TOTC_TNTC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyndale Commentary Volumes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/collec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0